import React from 'react';

import { Text } from '@change/ds-core-ui/Text';

import { Translate } from '@change-corgi/core-react/i18n';

import type { SignaturesCluster } from '../../shared/types';
import { PostalCodeValue } from '../PostalCodeValue';
import { SignatureDistributionIcon } from '../SignatureDistributionIcon';

type Props = {
	signaturesClusters: SignaturesCluster[];
	clusterPercentage: number;
};

export const SignatureDistributionSummary: React.FC<Props> = ({ signaturesClusters, clusterPercentage }) => {
	const { contributors } = signaturesClusters[0];

	return (
		<div className="text-left wrap-break-word">
			<div className="flex gap-2 align-middle">
				<div className="mr-2">
					<SignatureDistributionIcon fontSize={32} fill="none" strokeWidth={1.5} />
				</div>
				<div className="flex flex-col gap-1">
					<div>
						<Text as="span" fontWeight="normal" size="medium" variant="body" data-testid="cluster-percentage">
							<strong>{clusterPercentage.toFixed(0)}% </strong>
						</Text>
						<Text as="span" fontWeight="normal" size="medium" variant="body">
							<Translate value="corgi.petition_gamma.signature_map.body" />
						</Text>
					</div>
				</div>
				<div className="flex gap-2.5" data-qa="top-postal-code" data-testid="top-postal-code">
					{contributors
						.filter((_, index) => index < 3)
						.map((e) => e.postalCode)
						.map((postalCode) => (
							<PostalCodeValue key={postalCode} postalCode={postalCode} />
						))}
				</div>
			</div>
		</div>
	);
};
